// extracted by mini-css-extract-plugin
export var lg = "_1n-4";
export var md = "_1n-3";
export var sm = "_1n-2";
export var xs = "_1n-1";
export var xxs = "_1n-0";